import {isDefined} from 'shared/utils/custom-utils';
import type {Validator} from 'svelte-forms';
import {notBlankValidator, patternValidator, requiredValidator} from '../../shared/validators';
import type {Formatter, Parser} from '../../forms/types';
import type {MarkdownValueEditorValidations} from './types';

export function validatorFactory(validations: MarkdownValueEditorValidations) {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator());
    }

    if (isDefined(validations.notBlank) && validations.notBlank) {
        validators.push(notBlankValidator());
    }

    if (isDefined(validations.pattern)) {
        validators.push(patternValidator(new RegExp(validations.pattern)));
    }

    return validators;
}

export function markdownParser(): Parser {
    return (value: string) => {
        return value;
    }
}

export function markdownFormatter(): Formatter {
    return (value: string) => {
        return value;
    }
}